import React from 'react';
import Button from '@atlaskit/button/new';
import { Box, xcss } from '@atlaskit/primitives';
import ArrowDownIcon from '@atlaskit/icon/core/arrow-down';
import { useIntl } from '@atlassian/jira-intl';

import messages from './messages.tsx';

export const NewCommentsFloatingButton = ({
	unreadCommentsCount,
}: {
	unreadCommentsCount: number | undefined;
}) => {
	const { formatMessage } = useIntl();

	const handleClick = () => {
		// Implement the click handler logic here
	};

	return (
		<Box xcss={buttonStyles}>
			<Button
				testId="issue-activity-feed.ui.new-comments-floating-button.button"
				appearance="primary"
				iconBefore={ArrowDownIcon}
				onClick={handleClick}
			>
				{`${formatMessage(messages.newComments, { unreadCommentsCount })}`}
			</Button>
		</Box>
	);
};

const buttonStyles = xcss({
	position: 'fixed',
	left: '50%',
	bottom: 'space.300',
	transform: 'translateX(-50%)',
	zIndex: 'layer',
});
